var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-icon',{style:({color: '#1d6f42'}),attrs:{"component":_vm.ExcelDownloadSvg}})}
var staticRenderFns = []

export { render, staticRenderFns }